import React from 'react';

const Logo = ({ size = 'medium', showText = true, onClick = null }) => {
  // Size presets
  const sizeClasses = {
    small: 'h-12 sm:h-14',
    medium: 'h-16 sm:h-20 md:h-24',
    large: 'h-16 sm:h-20 lg:h-24 xl:h-28'
  };

  return (
    <div className="flex items-center space-x-4">
      <img 
        src="/logo-pakmoo.png" 
        alt="PAK MoO Logo" 
        className={`${sizeClasses[size]} w-auto object-contain logo-highlight ${onClick ? 'cursor-pointer' : ''}`}
        onClick={onClick}
      />
      {showText && (
        <div>
          <h1 className="text-2xl font-bold text-primary">PAK MoO</h1>
          <p className="text-xs text-secondary">Amanah & Berkualitas</p>
        </div>
      )}
    </div>
  );
};

export default Logo;

